<template>
  <div>
    <v-card>
      <v-card-title>
        <v-btn icon @click="$router.push('/admin/content-campaigns')"><v-icon>mdi-arrow-left</v-icon></v-btn>
        Ajanslar
        <v-spacer></v-spacer>
        <v-btn color="primary" outlined :loading="importing" @click="$refs.agencyFile.click()"
               title="Excel kolonları: Ajans Adı · Influencer Instagram · İlgili Kişi (sorumlu admin e-postası).">
          <v-icon left>mdi-file-upload</v-icon> Ajans ata (Excel)
        </v-btn>
        <input ref="agencyFile" type="file" accept=".xlsx" class="d-none" @change="onAgencyFile" />
      </v-card-title>

      <v-card-text>
        <v-text-field
          v-model="search"
          label="Ajans ara"
          prepend-inner-icon="mdi-magnify"
          clearable
          dense
          outlined
          hide-details
          style="max-width: 320px;"
        ></v-text-field>
      </v-card-text>

      <v-data-table :headers="headers" :items="filteredItems" :loading="loading" :items-per-page="25" @click:row="goInfluencers" style="cursor: pointer;">
        <template v-slot:item.influencerCount="{ item }">
          {{ item.visibleInfluencerCount }}<span v-if="item.visibleInfluencerCount !== item.influencerCount" class="grey--text"> / {{ item.influencerCount }}</span>
        </template>
        <template v-slot:item.managerNames="{ item }">
          <span v-if="item.managerNames && item.managerNames.length">{{ item.managerNames.join(", ") }}</span>
          <span v-else class="grey--text caption">—</span>
        </template>
        <template v-slot:item.password="{ item }">
          <span class="font-monospace">{{ revealed[item.id] ? item.password : "••••••••" }}</span>
          <v-btn icon x-small @click.stop="$set(revealed, item.id, !revealed[item.id])" :title="revealed[item.id] ? 'Gizle' : 'Göster'">
            <v-icon x-small>{{ revealed[item.id] ? "mdi-eye-off" : "mdi-eye" }}</v-icon>
          </v-btn>
          <v-btn icon x-small @click.stop="copy(item.password)" title="Şifreyi kopyala"><v-icon x-small>mdi-content-copy</v-icon></v-btn>
          <v-btn icon x-small @click.stop="regenerate(item)" title="Yeniden üret"><v-icon x-small>mdi-refresh</v-icon></v-btn>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-btn icon small @click.stop="copyLink(item)" title="Ajans linkini kopyala"><v-icon small>mdi-link-variant</v-icon></v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script lang="ts">
import NucleusComponentBase from "@/shared/application/nucleus-component-base";
import { Component } from "vue-property-decorator";

@Component
export default class ContentCampaignAgencies extends NucleusComponentBase {
  loading = true;
  importing = false;
  items: any[] = [];
  search = "";
  revealed: { [id: string]: boolean } = {};

  headers = [
    { text: "Ajans", value: "name" },
    { text: "Influencer", value: "influencerCount" },
    { text: "Sorumlu", value: "managerNames", sortable: false },
    { text: "Şifre", value: "password", sortable: false },
    { text: "", value: "actions", sortable: false, align: "end" },
  ];

  get campaignId(): string {
    return this.$route.params.id;
  }

  get filteredItems(): any[] {
    const q = (this.search || "").trim().toLowerCase();
    return this.items.filter((x) => !q || (x.name || "").toLowerCase().includes(q));
  }

  mounted() {
    this.load();
  }

  async load() {
    this.loading = true;
    const res = await this.nucleusService.get<any>(`/api/ContentCampaigns/${this.campaignId}/agencies`, false);
    if (!res.isError) this.items = res.content || [];
    this.loading = false;
  }

  goInfluencers(item: any) {
    this.$router.push(`/admin/content-campaigns/${this.campaignId}/agencies/${item.id}/influencers`);
  }

  async onAgencyFile(e: any) {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file) return;
    this.importing = true;
    const form = new FormData();
    form.append("file", file);
    const res = await this.nucleusService.postExcel<any>(`/api/ContentCampaigns/${this.campaignId}/agencies/import`, form);
    this.importing = false;
    if (!res.isError) {
      const r = res.content || {};
      const extra = `${r.unknownManagers ? ` · ${r.unknownManagers} sorumlu bulunamadı` : ""}${r.skipped ? ` · ${r.skipped} satır atlandı` : ""}`;
      this.swalToast(4000, "success", `${r.importedAgencies} ajans · ${r.importedInfluencers} influencer · ${r.matchedManagers} atama${extra}`);
      this.load();
    } else {
      this.swalToast(2500, "error", "Excel yüklenemedi");
    }
  }

  async regenerate(item: any) {
    const r = await this.swalConfirm("Yeni şifre üretilsin mi? Eski şifre geçersiz olur.");
    if (!(r as any).value) return;
    const res = await this.nucleusService.post<any>(`/api/ContentCampaigns/${this.campaignId}/agencies/${item.id}/regenerate-password`, {});
    if (!res.isError) {
      item.password = res.content.password;
      this.$set(this.revealed, item.id, true);
      this.swalToast(1500, "success", "Yeni şifre üretildi");
    } else {
      this.swalToast(2500, "error", "İşlem başarısız");
    }
  }

  agencyLink(item: any): string {
    const base = window.location.origin.replace(/\/$/, "");
    return `${base}/agency/${item.accessToken}`;
  }

  async copyLink(item: any) {
    await this.copy(this.agencyLink(item), "Ajans linki kopyalandı");
  }

  async copy(text: string, msg = "Kopyalandı") {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    this.swalToast(1500, "success", msg);
  }
}
</script>

<style scoped>
.font-monospace {
  font-family: monospace;
}
</style>
